import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef } from 'react';
import { VegetalCoverVM } from './VegetalCoversVM';
import { Input } from 'cd-eft/components/common/Input/Input';
import { ComboBox } from 'cd-eft/components/common/ComboBox/ComboBox';
import { RadioGroup } from 'cd-eft/components/common/RadioGroup';
import './VegetalCovers.scss';
import stores from '../../../../models/Stores'
import { WaterwaySizingCalculatorVM } from '../WaterwaySizingCalculatorVM';
import { TerraceInputsVM } from 'cd-eft/components/Design/Terrace/TerraceInputs/TerraceInputsVM';

const waterwayDesignStore = stores.AppStore.waterwayDesignStore;

interface IRedtardanceSubFormProps {
  vm: VegetalCoverVM;
}
interface IVegeFormProps {
  vm: WaterwaySizingCalculatorVM | TerraceInputsVM;
}


const RetardanceClassForm = observer((props: IRedtardanceSubFormProps) => {
  return (
    <Fragment>
      <div className={`row-left-label row-left-label-rc `}>
        <ComboBox
          idAndName="retardanceClassForStability"
          label="Retardance Class for Stability"
          aria-label="Retardance Class for Stability"
          valid={!props.vm.formValidation.retardanceClassForStability}
          value={props.vm.defineVegetalCoverForm.retardanceClassForm.retardanceClassForStability}
          onChange={props.vm.handleInputChange}
          options={props.vm.retardanceClassMenu}
          errorMsg={props.vm.formValidation.formErrors.retardanceClassForm.retardanceClassForStability}
          required={true}
          className={props.vm.retardanceErrorClass('retardanceClassForStability')}
        />
      </div>
      {/* </div> */}
      <div className="row-left-label row-left-label-rc">
        <ComboBox
          idAndName="retardanceClassForCapacity"
          label="Retardance Class for Capacity"
          aria-label="Retardance Class for Capacity"
          valid={!props.vm.formValidation.retardanceClassForCapacity}
          value={props.vm.defineVegetalCoverForm.retardanceClassForm.retardanceClassForCapacity}
          onChange={props.vm.handleInputChange}
          options={props.vm.retardanceClassMenu}
          errorMsg={props.vm.formValidation.formErrors.retardanceClassForm.retardanceClassForCapacity}
          required={true}
          className={props.vm.retardanceErrorClass('retardanceClassForCapacity')}
        />
      </div>
    </Fragment>
  );
});

const RetardanceCurveIndexForm = observer((props: IRedtardanceSubFormProps) => {
  return (
    <Fragment>
      <div className="row-left-label row-left-label-rci">
        <Input
          idAndName="rciStability"
          label="Retardance Curve Index for Stability"
          valid={!props.vm.formValidation.rciStability}
          value={props.vm.defineVegetalCoverForm.rciForm.rciStability}
          type="number"
          step={'0.01'}
          onChange={props.vm.handleInputChange}
          onBlur={(e) => props.vm.validateInput(e.target.name, e.target.value)}
          onKeyDown={props.vm.handleOnKeyDown}
          required={true}
          errorMsg={props.vm.formValidation.formErrors.rciForm.rciStability}
          className={props.vm.rciInputErrorClass('rciStability')}
        />
        <Input
          idAndName="rciCapacity"
          label="Retardance Curve Index for Capacity"
          valid={!props.vm.formValidation.rciCapacity}
          value={props.vm.defineVegetalCoverForm.rciForm.rciCapacity}
          type="number"
          step={'0.01'}
          onChange={props.vm.handleInputChange}
          onBlur={(e) => props.vm.validateInput(e.target.name, e.target.value)}
          onKeyDown={props.vm.handleOnKeyDown}
          required={true}
          errorMsg={props.vm.formValidation.formErrors.rciForm.rciCapacity}
          className={props.vm.rciInputErrorClass('rciCapacity')}
        />
      </div>
    </Fragment>
  );
});

const StemLengthForm = observer((props: IRedtardanceSubFormProps) => {
  return (
    <Fragment>
      <div className="row-left-label row-left-label-stem">
        <h3
          className="stem-length-header vegetal-p-header"
          aria-label="Stem Length/ Density for Stability"
          tabIndex={0}
        >
          Stem Length/ Density for Stability&nbsp;&nbsp;
        </h3>
        <div>
          <Input
            idAndName="stemLengthStabilityLength"
            label="Length (ft)"
            valid={!props.vm.formValidation.stemLengthStabilityLength}
            value={props.vm.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityLength}
            type="number"
            step={0.01}
            onChange={(e) => {
              props.vm.rciStabilityCalculated = false;
              props.vm.handleInputChange(e);
            }}
            onBlur={(e) => {
              props.vm.validateInput(e.target.name, e.target.value);
              props.vm.calculateStabilityRci();
            }}
            onKeyDown={props.vm.handleOnKeyDown}
            required={true}
            className={props.vm.stemInputErrorClass('stemLengthStabilityLength')}
          />{' '}
        </div>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Input
          idAndName="stemLengthStabilityDensity"
          label="Density (lb/sq.ft)"
          valid={!props.vm.formValidation.stemLengthStabilityDensity}
          onBlur={(e) => {
            props.vm.validateInput(e.target.name, e.target.value);
            props.vm.calculateStabilityRci();
          }}
          value={props.vm.defineVegetalCoverForm.stemLengthDensityForm.stemLengthStabilityDensity}
          type="number"
          onChange={(e) => {
            props.vm.rciStabilityCalculated = false;
            props.vm.handleInputChange(e);
          }}
          onKeyDown={props.vm.handleOnKeyDown}
          required={true}
          className={props.vm.stemInputErrorClass('stemLengthStabilityDensity')}
        />
        <div className="vegetal-p-header span-rci" contentEditable={false}>
          <label className="calculated-RCI" htmlFor="calculatedStabilityRci">RCI: </label>
          <input
            id="calculatedStabilityRci"
            name='calculatedStabilityRci'
            aria-label="calculated RCI"
            aria-invalid={!props.vm.formValidation.stemStabilityRci}
            // className="input"
            className={props.vm.rciStemInputErrorClass('stemStabilityRCI')}
            type="text"
            aria-readonly="true"
            readOnly
            value={props.vm.rciStabilityCalculated ? props.vm.defineVegetalCoverForm.stemLengthDensityForm.stemStabilityRci : ""}
          />
        </div>
      </div>
      <div className="row-left-label row-left-label-stem">
        <h3 className="stem-length-header vegetal-p-header" aria-label="stem length/density for capacity" tabIndex={0}>
          Stem Length/ Density for Capacity&nbsp;
        </h3>
        <Input
          idAndName="stemLengthCapacityLength"
          label="Length (ft)"
          valid={!props.vm.formValidation.stemLengthCapacityLength}
          value={props.vm.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityLength}
          type="number"
          step={0.01}
          onChange={(e) => {
            props.vm.rciCapacityCalculated = false;
            props.vm.handleInputChange(e);
          }}
          onBlur={(e) => {
            props.vm.validateInput(e.target.name, e.target.value);
            props.vm.calculateCapacityRci();
          }}
          onKeyDown={props.vm.handleOnKeyDown}
          required={true}
          className={props.vm.stemInputErrorClass('stemLengthCapacityLength')}
        />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Input
          idAndName="stemLengthCapacityDensity"
          label="Density (lb/sq.ft)"
          valid={!props.vm.formValidation.stemLengthCapacityDensity}
          onBlur={(e) => {
            props.vm.validateInput(e.target.name, e.target.value);
            props.vm.calculateCapacityRci();
          }}
          value={props.vm.defineVegetalCoverForm.stemLengthDensityForm.stemLengthCapacityDensity}
          type="number"
          onChange={(e) => {
            props.vm.rciCapacityCalculated = false;
            props.vm.handleInputChange(e)
          }}
          onKeyDown={props.vm.handleOnKeyDown}
          required={true}
          className={props.vm.stemInputErrorClass('stemLengthCapacityDensity')}
        />
        <div className="vegetal-p-header span-rci" contentEditable={false}>
          <label className="calculated-RCI" htmlFor="calculatedCapacityRci">RCI: </label>
          <input
            id="calculatedCapacityRci"
            name='calculatedCapacityRci'
            aria-label="calculated RCI"
            aria-invalid={!props.vm.formValidation.stemCapacityRci}
            // className="input"
            className={props.vm.rciStemInputErrorClass('stemCapacityRCI')}
            type="text"
            aria-readonly="true"
            readOnly
            value={props.vm.rciCapacityCalculated ? props.vm.defineVegetalCoverForm.stemLengthDensityForm.stemCapacityRci : ""}
          />
        </div>
      </div>
    </Fragment>
  );
});

const ManningnForm = observer((props: IRedtardanceSubFormProps) => {
  return (
    <Fragment>
      <div className="row-left-label row-left-label-manning">
        <Input
          idAndName="manningStability"
          label="Manning's n for Stability"
          valid={!props.vm.formValidation.manningStability}
          value={props.vm.defineVegetalCoverForm.manningForm.manningStability}
          type="number"
          onChange={props.vm.handleInputChange}
          onBlur={(e) => props.vm.validateInput(e.target.name, e.target.value)}
          onKeyDown={props.vm.handleOnKeyDown}
          required={true}
          step={'0.0001'}
          errorMsg={props.vm.formValidation.formErrors.manningForm.manningStability}
          className={props.vm.manningInputErrorClass('manningStability')}
        />

        <Input
          idAndName="manningCapacity"
          label="Manning's n for Capacity "
          valid={!props.vm.formValidation.manningCapacity}
          value={props.vm.defineVegetalCoverForm.manningForm.manningCapacity}
          type="number"
          onChange={props.vm.handleInputChange}
          onBlur={(e) => props.vm.validateInput(e.target.name, e.target.value)}
          onKeyDown={props.vm.handleOnKeyDown}
          required={true}
          step={'0.0001'}
          errorMsg={props.vm.formValidation.formErrors.manningForm.manningCapacity}
          className={props.vm.manningInputErrorClass('manningCapacity')}
        />
      </div>
    </Fragment>
  );
});

const VegetalCoverComp = (props: IVegeFormProps) => {
  let mode;
  if(props.vm instanceof WaterwaySizingCalculatorVM){
    mode = props.vm.mode;
  } else if(props.vm instanceof TerraceInputsVM){
    mode = 'terraceDesign';
  }
  
  const vm = useRef(props.vm.vegetalCoverVM).current;
  if (!vm) {
    return <></>;
  }
  
  return (
    <div className="vegetal-container col">
      {mode !== 'terraceDesign' && <h3 className="wsc-section-header" tabIndex={0} aria-label='vegetal cover'>
        Vegetal Cover
      </h3>}
      <div className="combo-box-container">
        <ComboBox
          idAndName="vegetalCoverDropdown"
          label="Select a Vegetal Cover Type"
          aria-label="Select a Vegetal Cover Type"
          valid={!vm.formValidation.vegetalCoverDropdown}
          value={vm.defineVegetalCoverForm.vegetalCoverDropdown}
          onChange={vm.handleVegetalCoverDropdownInputChange}
          onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
          options={vm.vegetalCoverOptions}
          errorMsg={vm.formValidation.formErrors.vegetalCoverDropdown}
          required={true}
          className={vm.vegetalCoverErrorClass()}
        />
      </div>
      {mode === 'design' || mode === 'standalone' || mode === 'terraceDesign'?
      <div className="row manual-entry-box">
        <Input
          label="Or Manually Enter Vegetal Cover Type Description"
          idAndName="manualboxOne"
          aria-unitLabel="Or Manually Enter Vegetal Cover Type Description"
          type="text"
          value={vm.defineVegetalCoverForm.manualboxOne}
          onChange={vm.handleInputChange}
          onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
          required={true}
          valid={!vm.formValidation.manualboxOne}
          errorMsg={vm.formValidation.formErrors.manualboxOne}
          className={vm.dropdownErrorClassOne('manualboxOne')}
          disabled={vm.disableVegetalCoverManualInputs}
        />
        <Input
          label="Manually Enter Vegetal Cover Factor Value"
          idAndName="manualboxTwo"
          aria-unitLabel="select or enter numeric value"
          type="number"
          value={vm.defineVegetalCoverForm.manualboxTwo}
          onChange={vm.handleInputChange}
          onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
          onKeyDown={vm.handleOnKeyDown}
          required={true}
          step={'0.01'}
          valid={!vm.formValidation.manualboxTwo}
          className={vm.dropdownErrorClassTwo('manualboxTwo')}
          disabled={vm.disableVegetalCoverManualInputs}
          errorMsg={vm.formValidation.formErrors.manualboxTwo}
        />
      </div> : null}
      {mode !== 'terraceDesign' && <hr></hr>}
      {mode !== 'terraceDesign' && <h3 className="wsc-section-header" tabIndex={0} aria-label='define retardance methods'>Define Retardance Methods</h3>}
      <div className="row control-radio-group">
        <RadioGroup
          labelId="define-retardance-methods"
          items={[
            {
              id: 'retClassStr',
              name: 'retClassStr',
              label: 'Retardance Class',
              className: ' usa-radio__input--tile',
              onChange: vm.selectRetardanceMethod,
              checked: vm.retardanceClassControl,
            },
            {
              id: 'rci',
              name: 'rci',
              label: 'Retardance Curve Index',
              className: 'usa-radio__input--tile',
              onChange: vm.selectRetardanceMethod,
              checked: vm.retardanceCurveControl,
            },
            {
              id: 'stemLength',
              name: 'stemLength',
              label: 'Stem Length/Density',
              className: 'usa-radio__input--tile',
              onChange: vm.selectRetardanceMethod,
              checked: vm.stemLengthControl,
            },
            {
              id: 'manningsN',
              name: 'manningsN',
              label: "Manning's n",
              className: 'usa-radio__input--tile',
              onChange: vm.selectRetardanceMethod,
              checked: vm.manningControl,
            },
          ]}
        />
      </div>

      {vm.RetardanceClassControl === 0 ? <RetardanceClassForm vm={vm} /> : null}
      {vm.RetardanceClassControl === 1 ? <RetardanceCurveIndexForm vm={vm} /> : null}
      {vm.RetardanceClassControl === 2 ? <StemLengthForm vm={vm} /> : null}
      {vm.RetardanceClassControl === 3 ? <ManningnForm vm={vm} /> : null}
    </div>
  );
};

export const VegetalCoverComponent = observer(VegetalCoverComp);
